/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.fabricantes': 'Fabricantes',
'fabricantes.agregarFabricantes': 'Create Fabricantes',
'fabricantes.modificarFabricantes': 'Edit Fabricantes',
'fabricantes.eliminarFabricantes': 'Delete Fabricantes',
'fabricantes.fabricanteId': 'Fabricante   Id ',
'fabricantes.empresaId': ' Empresa   Id ',
'fabricantes.fabricanteDescripcion': ' Fabricante   Descripcion',
'fabricantes.fabricantes': 'Fabricantes',
'fabricantes.verFabricantes': 'View Fabricantes',
};

